<template>
	<div>
		<div class=" button btn-action bg-rouge text-white"
			:class="{active: active}"
			@click="$emit('input', name)"
			>
				<div>
					<span v-html="label"></span>
					<q-icon name="arrow_forward"/>
				</div>
			</div>
	</div>
</template>

<script>
export default {
	name: "ActionBtn",
	props: {
		value: String,
		name: String,
		label: String
	},
	data() {
		return {
			active: false
		}
	},
	watch: {
		value(n) {
			if (n === this.name)
				this.active = true
			else
				this.active = false

			return n
		}
	}
}
</script>
